import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";

const ITEMS = [
  "$TGB",
  "THE GREATER BULL",
  "BUY ON PUMP.FUN",
  "1000X POTENTIAL",
  "COMMUNITY POWERED",
  "LP BURNED",
  "0% TAX",
  "LONG TERM",
  "LEGENDARY",
];

export const TickerMarquee = () => {
  return (
    <div
      className="relative bg-gold border-y-2 border-black py-3 md:py-4 overflow-hidden"
      data-testid="ticker-marquee"
    >
      <Marquee speed={60} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-xl md:text-2xl uppercase text-black tracking-wide mx-6">
              {item}
            </span>
            <Flame className="w-4 h-4 text-black/70" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
